import React__default from 'react';
import PropTypes from 'prop-types';
import { StyledSpinnerContainer, StyledSpinner } from './Spinner.style.js';
import { useTranslation } from '../useTranslation/use-translation.js';
import { Spacer } from '../Spacer/Spacer.js';

const Spinner = _ref => {
  let {
    align,
    ariaLabel,
    children,
    className,
    size
  } = _ref;
  const {
    getTranslation
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement(StyledSpinnerContainer, {
    align: align,
    "aria-label": ariaLabel || (children ? undefined : "".concat(getTranslation('loading'), "\u2026")),
    className: className,
    role: "status"
  }, /*#__PURE__*/React__default.createElement(StyledSpinner, {
    size: size
  }), children && /*#__PURE__*/React__default.createElement(Spacer, {
    marginLeft: "md"
  }, children));
};
Spinner.displayName = 'Spinner';
Spinner.propTypes = {
  align: PropTypes.oneOf(['center']),
  /**
   * Generic "Loading…" will be used automatically when ariaLabel and children are undefined.
   */
  ariaLabel: PropTypes.string,
  /**
   * Text content of the component.
   */
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm'])
};

export { Spinner };
